import { Accessibility, Gauge, Search } from "lucide-react";
import { CATEGORY, ScoreRing } from "./qualityUi";

const CARDS = [
  ["seo", Search, "Titoli, descrizioni, canonical, sitemap, link"],
  ["performance", Gauge, "Peso, immagini, caricamento della prima schermata"],
  ["accessibility", Accessibility, "Nomi di link e pulsanti, moduli, contrasto, titoli"],
];

export default function ScoreCards({ quality }) {
  const count = (c, lv) => (quality.items || []).filter((i) => i.category === c && i.level === lv).length;
  return (
    <div className="grid gap-3 sm:grid-cols-3" data-testid="quality-scores">
      {CARDS.map(([c, Icon, hint], i) => (
        <div key={c} className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 animate-in fade-in slide-in-from-bottom-1" style={{ animationDelay: `${i * 80}ms`, animationFillMode: "both" }}>
          <ScoreRing value={quality.scores?.[c]} testid={`quality-score-${c}`} />
          <div className="min-w-0">
            <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-900"><Icon size={14} className="text-slate-400" />{CATEGORY[c]}</p>
            <p className="mt-0.5 text-[11px] leading-snug text-slate-500">{hint}</p>
            <p className="mt-1 text-[11px] text-slate-600">{count(c, "error") + count(c, "warning")} da sistemare · {count(c, "advice")} consigli</p>
          </div>
        </div>
      ))}
    </div>
  );
}
